import React from 'react';
import { trackWhatsAppClick, trackCtaClick } from '../../../utils/gtm';
import { IconArrowRight, IconStar, IconWhatsApp } from '../components/Icons';
import { SKYLINE_IMAGE } from './HeroSection';

const CTASection = ({ onOpenModal }) => (
  <section className="bk-final" data-screen-label="Final CTA">
    <div className="bk-final-bg" style={{ backgroundImage: `url(${SKYLINE_IMAGE})` }} aria-hidden="true" />
    <div className="bk-container">
      <div className="bk-final-card">
        <span className="bk-pill bk-pill--dark">
          <span className="bk-dot" aria-hidden="true" />
          [ Final closing protocol ]
        </span>

        <h2 className="bk-final-title">
          Next month's books, closed by the <span className="bk-accent">10th.</span>
        </h2>

        <p className="bk-final-desc">
          Fixed monthly fee. Zero surprise invoices. Move your bookkeeping to WhatsApp in 15 minutes and experience
          guaranteed DIFC-grade close precision.
        </p>

        <p className="bk-final-trust">
          <span className="bk-final-stars" aria-label="5 out of 5 stars">
            {[0, 1, 2, 3, 4].map((s) => <IconStar key={s} size={11} />)}
          </span>
          Trusted by 120+ active UAE mainland &amp; freezone entities across DIFC, DMCC &amp; Mainland
        </p>

        <div className="bk-final-actions">
          <button
            type="button"
            onClick={() => {
              trackCtaClick('final_cta_book_consultation');
              if (onOpenModal) onOpenModal();
            }}
            className="bk-btn bk-btn--orange bk-btn--glow gtm-cta-btn"
            data-gtm-id="cta-book-consultation"
            id="ctaBookConsultationBtn"
          >
            <span>Get my fixed quote</span>
            <IconArrowRight />
          </button>

          <a
            href="https://wa.me/971542119784"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackWhatsAppClick('final_cta_whatsapp')}
            className="bk-btn bk-btn--wa gtm-whatsapp-btn"
            data-gtm-id="cta-whatsapp"
            id="ctaWhatsappBtn"
          >
            <IconWhatsApp size={18} />
            <span>Chat on WhatsApp</span>
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default CTASection;
